import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { Container } from '@mui/system';
import Grid from '@mui/material/Grid';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import UpdateUser from './UpdateUser'
import AddUser from './AddUser';
import LoaderDialog from './LoaderDialog'
import { AuthContext } from '../authContext/AuthContext';
import UpdateUserPassword from './UpdateUserPassword';

const ListUsers = () => {
  const isMounted = React.useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const [data, setData] = useState();
  const [selectedRow, setSelectedRow] = useState();
  const [contextMenu, setContextMenu] = useState(null);
  const [addDialog, setAddDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [updatePasswordDialog, setUpdatePasswordDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const {user} = useContext(AuthContext)

  useEffect(() => {
    loadData(user);
  },[user]);

  const loadData = async(user) => {
    try {
      setLoading(true)
      const columns = [
        {"field": "username", "headerName": "User Name"},
        {"field": "email", "headerName": "Email", width: 200},
        {"field": "name", "headerName": "Display Name", width: 200},
        {"field": "phone", "headerName": "Phone", width: 125},
        {"field": "isAdmin", "headerName": "Admin"},
        {"field": "shoopNames", "headerName": "Allowed Shops", width: 450}
      ]
      let sd = []
      const res = await axios.get("/users", {headers: {token:"Bearer " + user.token}})
      if (!isMounted.current) return;
      res.data.map(async (item)=> {
        let shoopNames = []
        item.allowedShops.map((shop)=> {
          shoopNames.push(shop.shopname + "(" + shop.shopkey + ")")
          return shop
        })
        sd.push({...item, "id": item._id, shoopNames: shoopNames.join(", ")})
      });
      if(sd) {
        setData({"rows": sd, "columns": columns})
      }
      setLoading(false)
    } catch (err) {
      console.log(err)
      if (isMounted.current) setLoading(false)
    }
  }
  
  const handleContextMenu = (event) => {
    event.preventDefault()
    setSelectedRow(event.currentTarget.getAttribute('data-id'))
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null,
    );
  };

  const updateUser = async() => {
    handleClose()
    setUpdateDialog(true);
  }
  const updatePasswordUser = async() => {
    handleClose()
    setUpdatePasswordDialog(true);
  }
  const addUser = async() => {
    handleClose()
    setAddDialog(true);
  }
  const handleClose = () => {
    setContextMenu(null);
  };

  const handleUpdateClose = () => {
    setUpdateDialog(false);
    loadData(user);
  };
  const handleUpdatePasswordClose = () => {
    setUpdatePasswordDialog(false);
    loadData(user);
  };
  const handleAddClose = () => {
    setAddDialog(false);
    loadData(user);
  };
  return (
    <div>
    <Container maxWidth="false" disableGutters sx={{height: "85vh", width: "100vw"}}>
      <LoaderDialog open={loading} title="Loading Users ..."/>
      <Grid container>
        {data && 
        <div>
          <DataGrid {...data} 
            components={{ Toolbar: GridToolbar }}  
            componentsProps={{row: {onContextMenu: handleContextMenu,style: { cursor: 'context-menu' }}}} 
            sx={{height: "92vh", width: "100vw"}}/>
          <Menu
            open={contextMenu !== null}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={
              contextMenu !== null
                ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                : undefined
            }
            componentsProps={{
              root: {
                onContextMenu: (e) => {
                  e.preventDefault();
                  handleClose();
                },
              },
            }}>
            <MenuItem onClick={addUser}>Add</MenuItem>
            <MenuItem onClick={updateUser}>Update</MenuItem>
            <MenuItem onClick={updatePasswordUser}>Change Password</MenuItem>
          </Menu>
        </div>}
      </Grid>
    </Container>
    <AddUser addDialog={addDialog} handleClose={handleAddClose}/>
    <UpdateUser updateDialog={updateDialog} handleClose={handleUpdateClose} updateUserId={selectedRow}/>
    <UpdateUserPassword updateDialog={updatePasswordDialog} handleClose={handleUpdatePasswordClose} updateUserId={selectedRow}/>
    </div>
  )
}

export default ListUsers
